import { useEffect, useMemo, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { getKazoos, getKazoosforStaff } from '../../features/kazooEventSlice.js'
import { acceptKazooInvitationVendor } from '../../features/kazooEventSlice.js'
import VendorDashboard from '../../components/UserDashboard/Vendor/index.jsx'
import { useNavigate } from 'react-router-dom'
import { LeaveKazooPopup } from '../../components/popups/LeaveKazooPopup.jsx'

export const VendorWeddingsPage = ({ isStaff = false }) => {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const user = useSelector((state) => state.auth.user)
	const [popupToggle, setPopupToggle] = useState(false)
	const [kazooId, setKazooId] = useState('')

	const invitedKazoos = useSelector((state) => state.kazooEvent.kazoos || [])
	const togglePopup = () => setPopupToggle((prev) => !prev)

	const handleAccept = (kazooId) => {
		dispatch(acceptKazooInvitationVendor({ kazooId, vendorId: user._id }))
	}

	const handleReject = (id) => {
		setKazooId(id)
		togglePopup()
	}

	useEffect(() => {
		if (!isStaff) dispatch(getKazoos())
		else dispatch(getKazoosforStaff())
	}, [dispatch])

	const formattedData = useMemo(
		() =>
			invitedKazoos?.map((kazoo) => {
				return {
					id: kazoo._id,
					image: kazoo.image,
					name: kazoo.kazooName,
					engageCouple:
						(kazoo.brideFirstName ?? 'Marrier') +
						' & ' +
						(kazoo.groomFirstName ?? 'Marrier'),
					status: kazoo.status,
					budget: kazoo.budget ?? 0,
					guestCount: kazoo.guestCount ?? 0,
					date: kazoo?.date?.slice(0, 10),
					accept: () => handleAccept(kazoo._id),
					reject: () => handleReject(kazoo._id),
					viewDetails: () =>
						navigate(`/wedding/details/${kazoo._id}`),
				}
			}),
		[invitedKazoos]
	)

	return (
		<>
			<VendorDashboard data={formattedData} isStaff={isStaff} />
			{popupToggle && (
				<LeaveKazooPopup
					popupToggle={popupToggle}
					userId={user._id}
					kazooId={kazooId}
					clickHandler={togglePopup}
				/>
			)}
		</>
	)
}
